import React, { useState } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import check from 'images/check.png';
import { emailRegexValidate } from './constants';
import * as S from './styles';
import Swal from 'sweetalert2'

function Form() {
  const { register, handleSubmit, errors } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [
    isSuccessfullySubmitted,
    setIsSuccessfullySubmitted,
  ] = useState(false);

  const onSubmit = (data) => {
    setIsLoading(true);
    const postData = {
      account: 'stmforum',
      contact: {
        email: data.email,
        firstName: data.name,
        lastName: '',
      },
      contactTags: ['wwam2024'],
      contactLists: [98]
    };
    axios
      .post('https://api.istack.network/ac', postData)
      .then(()=>{
        setIsLoading(false);
        Swal.fire({
          title: 'Sent! Please check your email.',
          text: 'Note: Please allow up to 10 minutes for delivery.',
          icon: 'success',
          confirmButtonText: 'Okay'
        });

        setIsSuccessfullySubmitted(true);
        if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({
          'event': 'Lead',
          'id': 'WWAM 2024 Form Submit'
        });
        if (window._tfa &&window._tfa.push) window._tfa.push({notify: 'event', name: 'lead', id: 1361426});
      })
      .catch(() => {
        alert('Cannot connect to server, Please try again later.');
        setIsLoading(false);
      });
  };

  const onError = (data) => {
    const errorText = data.name ? 'Valid name is required.' : 'Valid email is required.';
    Swal.fire({
      title: errorText,
      icon: 'error',
      confirmButtonText: 'Okay'
    })
  };
  return (
    <S.Form onSubmit={handleSubmit(onSubmit, onError)}>
      <section>
        <S.Input
          type="text"
          className="input-field"
          placeholder="Name"
          name="name"
          ref={register({
            required: true,
          })}
          isError={errors.name}
        />
        <S.Input
          type="text"
          className="input-field"
          placeholder="Email Address"
          isError={errors.email}
          name="email"
          ref={register({
            required: true,
            pattern: {
              value: emailRegexValidate,
            },
          })}
        />
      </section>
      <S.SubmitBtn type="submit" className="submit-btn" disabled={!!isLoading}>
        {isLoading ? 'SENDING...' : 'SEND ME THE FREE PDF NOW!'}
      </S.SubmitBtn>
      {isSuccessfullySubmitted && (
        <S.Success>
          <img src={check} alt="" />
          <p>Form submitted successfully!</p>
        </S.Success>
      )}
    </S.Form>
  );
}

export default Form;
